import { AbsenceTypeName } from "~/modules/absence/api/absence/absenceTypes.ts";
import { invoiceStatusId } from "~/modules/billing/api/invoiceStatus/invoiceStatusId.ts";
import { invoiceTypeId } from "~/modules/billing/api/invoiceType.ts";
import { BonusTypeName } from "~/modules/humanResources/api/bonusType/bonusTypes.ts";
import { CareerLevelName } from "~/modules/humanResources/api/careerLevel/careerLevelTypes.ts";
import { EmploymentTypeName } from "~/modules/humanResources/api/employmentType/employmentTypeTypes.ts";
import { TaxClassName } from "~/modules/humanResources/api/taxClass/taxClassTypes.ts";
import { ProjectTagTypeId } from "~/modules/project/api/projectTag/projectTagTypes.ts";
import { TimeTrackingTypeId } from "~/modules/timeTracking/api/timeTrackingType/timeTrackingTypeTypes.ts";
import { GenderNames, PermissionNames, WorkingStatusNames } from "~/types/entityNames.ts";

export default {
	absenceType: {
		[AbsenceTypeName.Holiday]: "Feiertag",
		[AbsenceTypeName.InternalEvent]: "Interner Event",
		[AbsenceTypeName.MaternityLeave]: "Mutterschutz",
		[AbsenceTypeName.ParentalLeave]: "Elternzeit",
		[AbsenceTypeName.Sabbatical]: "Sabbatical",
		[AbsenceTypeName.Sick]: "Krank",
		[AbsenceTypeName.Special]: "Sondereffekt",
		[AbsenceTypeName.Training]: "Schulung",
		[AbsenceTypeName.Vacation]: "Urlaub",
	},
	bonusType: {
		[BonusTypeName.Fixed]: "Fixbonus",
		[BonusTypeName.Spot]: "Spot-Award",
		[BonusTypeName.Special]: "Sonderbonus",
		[BonusTypeName.Yearly]: "Jahresbonus",
	},
	careerLevel: {
		[CareerLevelName.Analyst]: "Analyst",
		[CareerLevelName.Consultant]: "Consultant",
		[CareerLevelName.SeniorConsultant]: "Senior Consultant",
		[CareerLevelName.Manager]: "Manager",
		[CareerLevelName.SeniorManager]: "Senior Manager",
		[CareerLevelName.Partner]: "Partner",
		[CareerLevelName.Assistant]: "Assistant",
		[CareerLevelName.Student]: "Student",
		[CareerLevelName.IT]: "IT",
		[CareerLevelName.ManagingDirector]: "Geschäftsführer",
	},

	employmentType: {
		[EmploymentTypeName.Employed]: "Festangestellt",
		[EmploymentTypeName.Freelancer]: "Freelancer",
		[EmploymentTypeName.Left]: "Ausgeschieden",
		[EmploymentTypeName.Student]: "Werkstudent",
		[EmploymentTypeName.Intern]: "Praktikant",
	},
	gender: {
		[GenderNames.Male]: "Männlich",
		[GenderNames.Female]: "Weiblich",
		[GenderNames.Diverse]: "Divers",
	},
	invoiceType: {
		[invoiceTypeId.RegularInvoice]: "Ausgangsrechnung",
		[invoiceTypeId.ReversalInvoice]: "Stornorechnung",
		[invoiceTypeId.SelfBilledInvoice]: "Kundengutschrift",
		[invoiceTypeId.AdvanceInvoice]: "Vorauszahlungsrechnung",
	},
	invoiceTypeShort: {
		[invoiceTypeId.RegularInvoice]: "Rechnung",
		[invoiceTypeId.ReversalInvoice]: "Storno",
		[invoiceTypeId.SelfBilledInvoice]: "Gutschrift",
		[invoiceTypeId.AdvanceInvoice]: "Vorauszahlung",
	},
	orderInvoicingStatus: {
		[invoiceStatusId.Pending]: "Offen",
		[invoiceStatusId.Draft]: "Todo",
		[invoiceStatusId.SentToClient]: "Versendet",
		[invoiceStatusId.Paid]: "Bezahlt",
		[invoiceStatusId.Reversed]: "Storniert",
	},
	permission: {
		[PermissionNames.CanManageAbsences]: "Abwesenheiten anderer Benutzer verwalten",
		[PermissionNames.CanManageInvoices]: "Rechnungen verwalten",
		[PermissionNames.CanViewInvoices]: "Rechnungen ansehen",
		[PermissionNames.CanManageProjects]: "Projekte verwalten",
		[PermissionNames.CanManageProjectTags]: "Projekt-Tags verwalten",
		[PermissionNames.CanManagesStaffSalaries]: "Gehälter verwalten",
		[PermissionNames.CanManageStaff]: "Mitarbeiter verwalten",
		[PermissionNames.CanManageTimeTrackings]: "Zeiterfassungen anderer Benutzer verwalten",
		[PermissionNames.CanManageUsers]: "User verwalten",
		[PermissionNames.CanViewAbsences]: "Abwesenheiten nutzen",
		[PermissionNames.CanViewReports]: "Reports nutzen",
	},
	projectTagTypes: {
		[ProjectTagTypeId.Products]: "NN Produkte",
		[ProjectTagTypeId.SubProducts]: "NN Sub-Produkte",
		[ProjectTagTypeId.MethodsAndFrameworks]: "Methoden & Frameworks",
		[ProjectTagTypeId.Apps]: "Apps",
		[ProjectTagTypeId.Partners]: "Partner",
		[ProjectTagTypeId.ProjectKeyDeliverables]: "Wichtigste Projektergebnisse",
	},
	taxClass: {
		[TaxClassName.I]: "Steuerklasse I",
		[TaxClassName.II]: "Steuerklasse II",
		[TaxClassName.III]: "Steuerklasse III",
		[TaxClassName.IV]: "Steuerklasse IV",
		[TaxClassName.V]: "Steuerklasse V",
	},
	timeTrackingTypes: {
		[TimeTrackingTypeId.Project]: "Projekt",
		[TimeTrackingTypeId.Internal]: "Intern",
		[TimeTrackingTypeId.Sales]: "Sales",
		[TimeTrackingTypeId.PartTime]: "Teilzeit",
	},
	workingStatus: {
		[WorkingStatusNames.Active]: "Aktiv",
		[WorkingStatusNames.Quotation]: "Angebot",
		[WorkingStatusNames.Hold]: "On hold",
		[WorkingStatusNames.Cancelled]: "Verloren",
		[WorkingStatusNames.Closed]: "Abgeschlossen",
	},
};
